import { environment } from "@web-src/environments/environment";
import { ChatMessagePayloadAttachment } from "@web-src/features/chats/types";

export const getChatMessageAttachmentUrls = (
  entityId: string,
  attachment: ChatMessagePayloadAttachment
) => ({
  preview: `${environment.apiUrl}/api/auth/attachment/preview?file=${entityId}/${attachment.uid}`,
  stream: `${environment.apiUrl}/api/auth/attachment/stream?file=${entityId}/${attachment.uid}`,
});
